// config/najva.ts
export const NAJVA_CONFIG = {
  websiteId: process.env.NEXT_PUBLIC_NAJVA_WEBSITE_ID ?? '',
  scriptUrl: process.env.NEXT_PUBLIC_NAJVA_SCRIPT_URL ?? '',
  serviceWorker: '/najva-messaging-sw.js',
  enabled: process.env.NEXT_PUBLIC_NAJVA_ENABLED === 'true',
};
